export default __webpack_public_path__ + "static/media/blogInnerPage.567ac1f3.jpg";